import React, { useState, useEffect, useRef } from 'react'
import parse from 'html-react-parser'

import LeftArrow from '@components/Icons/LeftArrow.jsx'
import RightArrow from '@components/Icons/RightArrow.jsx'

import { getPageById } from '@api/shopify'

import { getUniqueListBy, shuffle } from '@utils/utils.js'

import AvatarImages from '@components/Classes/DefaultImages.js'

//

const shuffledAvatars = shuffle(AvatarImages)

//

const ExpertProfiles = ({ classesProducts }) => {
    const maxScrollWidth = useRef(0)
    const [currentIndex, setCurrentIndex] = useState(0)
    const carousel = useRef(null)
    const totalSlides = classesProducts.length
    const [scrollX, setScrollX] = useState(0)
    const [scrollEnd, setScrollEnd] = useState(false)

    const [profiles, setProfiles] = useState([])

    let expertProfileIds = classesProducts.map((p) => {
        const metafields = p?.metafields?.filter((m) => {
            return m.namespace === 'meeting' && m.key === 'json'
        })

        const metafieldsJson =
            metafields?.length > 0 ? JSON.parse(metafields[0].value) : {}

        //
        return {
            id:
                metafieldsJson?.profile_page_1
                    ?.replace('OnlineStore', '')
                    .replace(/['"]+/g, '')
                    .replace(/[\])}[{(]/g, '')
                    .toString() || '',
            classId: p.id,
        }
    })

    expertProfileIds = getUniqueListBy(expertProfileIds, 'id')

    expertProfileIds = expertProfileIds.filter((e) => {
        return e.id !== ''
    })

    //

    let allProfiles = []

    const identifiers = [
        {
            namespace: 'custom_fields',
            key: 'default_image',
        },
        {
            namespace: 'custom_fields',
            key: 'default_image_alt_text',
        },
    ]

    useEffect(() => {
        if (expertProfileIds.length > 0) {
            expertProfileIds.forEach((e) => {
                const profileId = e.id
                getPageById(profileId, identifiers).then((expertData) => {
                    const profileData = expertData?.data?.page
                    const metafields = profileData?.metafields
                    const defaultImage = metafields.find(
                        (m) => m.key === 'default_image'
                    ).value
                    const defaultImageAlt = metafields.find(
                        (m) => m.key === 'default_image_alt_text'
                    ).value

                    const bioParagraphs = profileData.body?.split('</p>') || []
                    const bioFirst = bioParagraphs[0] + '</p>' || ''

                    const profile = {
                        name: profileData.title || '',
                        bio: bioFirst,
                        image: defaultImage,
                        imageAlt: defaultImageAlt,
                        handle: profileData.handle || '',
                        url: profileData.onlineStoreUrl || '',
                        classId: e.classId,
                    }

                    allProfiles = [...allProfiles, profile]
                    setProfiles([...allProfiles])
                })
            })
        }
    }, [])

    //

    const movePrev = () => {
        if (carousel.current !== null) {
            let child
            let frameWidth = carousel.current.firstChild.offsetWidth

            let scrollFrame =
                Math.ceil(carousel.current.offsetWidth / frameWidth) - 1
            if (window.innerWidth > 700) {
                carousel.current.scrollLeft -= frameWidth * 2
            } else {
                carousel.current.scrollLeft -= frameWidth * 2
            }
        }
    }

    const moveNext = () => {
        if (carousel.current !== null) {
            let frameWidth = carousel.current.firstChild.offsetWidth

            let scrollFrame =
                Math.ceil(carousel.current.offsetWidth / frameWidth) - 1

            if (window.innerWidth > 700) {
                carousel.current.scrollLeft += frameWidth * 2
            } else {
                carousel.current.scrollLeft += frameWidth * 2
            }
        }
    }

    useEffect(() => {
        maxScrollWidth.current = carousel.current
            ? carousel.current.scrollWidth - carousel.current.offsetWidth
            : 0
    }, [])

    const scrollFunction = (e) => {
        setScrollX(carousel.current.scrollLeft)
        if (
            Math.floor(
                carousel.current.scrollWidth - carousel.current.scrollLeft
            ) <= carousel.current.offsetWidth
        ) {
            setScrollEnd(true)
        } else {
            setScrollEnd(false)
        }
    }

    return (
        <div className="expert-profiles-outer bg-beige">
            <div className="expert-profiles-inner wrap-xl mx-auto py-12 overflow-x-hidden lg:px-12 2xl:px-0">
                <h2 className="text-2xl px-3 lg:px-0 mb-3 lg:mb-0">
                    Expert Profiles
                </h2>
                <div className="expert-profiles-wrap relative overflow-x-hidden lg:ml-[25%] px-3 lg:px-0">
                    <ul
                        onScroll={(e) => scrollFunction(e)}
                        ref={carousel}
                        className="expert-profiles-list relative flex overflow-x-scroll scroll-smooth z-0"
                    >
                        {profiles.map((p, i) => {
                            let index = i
                            if (i > 4) {
                                index = i - 5
                            }

                            const image = AvatarImages[index]
                            const imageSrc =
                                image?.imageSrc || AvatarImages[0].imageSrc
                            const imageAlt = image?.imageAlt || 'expert avatar'

                            //

                            let profileUrl = `/pages/${p.handle}?image=${p.image}&imageAlt=${p.imageAlt}&name=${p.name}&classId=${p.classId}`

                            return (
                                <li
                                    key={p.name}
                                    className="expert-profiles-item flex flex-col px-1 lg:px-3 flex-grow-0 basis-1/2 lg:basis-1/3 min-w-[50%] lg:min-w-[33%]"
                                >
                                    <div className="expert-profiles-item-inner">
                                        <div className="expert-profiles-item-image">
                                            <img src={imageSrc} alt={null} />
                                        </div>
                                        <div className="expert-profiles-item-content mt-3">
                                            <h3 className="text-lg mb-2">
                                                <a href={profileUrl}>
                                                    {p.name}
                                                </a>
                                            </h3>
                                            <div className="text-sm font-normal">
                                                {parse(p.bio)}
                                                <p className="mt-3">
                                                    <a
                                                        className="underline"
                                                        href={profileUrl}
                                                    >
                                                        View full bio
                                                    </a>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            )
                        })}
                    </ul>
                </div>

                <div className="profiles-nav flex gap-4 px-3 lg:px-0 mt-6 lg:mt-0">
                    <span
                        className={`angle-left ${
                            scrollX === 0
                                ? 'cursor-not-allowed opacity-50'
                                : 'cursor-pointer'
                        }`}
                        onClick={movePrev}
                        disabled={scrollX === 0}
                    >
                        <LeftArrow width="w-[32px]" />
                    </span>
                    <span
                        className={`angle-right ${
                            scrollEnd
                                ? 'cursor-not-allowed opacity-50'
                                : 'cursor-pointer'
                        }`}
                        onClick={moveNext}
                        disabled={scrollEnd}
                    >
                        <RightArrow width="w-[32px]" />
                    </span>
                </div>
            </div>
        </div>
    )
}

export default ExpertProfiles
